// growthos/warchest-frontend/react-app/src/pages/scenario-builder/v3/api/deleteComments.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { INSIGHTS_BACKEND_URL } from "@/lib/axios";
import { useScenarioBuilderClient } from "@/pages/scenario-builder/api/hooks/useScenarioBuilderClient";
import { axiosApi } from "@/Utils";

import { deleteCommentV2 } from "../v2/deleteComment";

interface DeleteCommentParams {
  scenarioId: string;
  commentId: string;
}

export const deleteComment = async ({
  scenarioId,
  commentId,
}: DeleteCommentParams): Promise<void> => {
  await axiosApi.delete(`/api/v2/scenarios-new/${scenarioId}/comment/${commentId}`, {
    baseURL: INSIGHTS_BACKEND_URL,
  });
};

interface UseDeleteCommentOptions {
  scenarioId: string;
  isScenariosApiEnabled: boolean;
}

export const useDeleteComment = ({
  scenarioId,
  isScenariosApiEnabled = false,
}: UseDeleteCommentOptions) => {
  const queryClient = useQueryClient();
  const scenarioBuilderClient = useScenarioBuilderClient();

  const deleteCommentFn = async (commentId: string) => {
    if (isScenariosApiEnabled) {
      return deleteCommentV2({ scenarioBuilderClient, scenarioId, commentId });
    }
    return deleteComment({ scenarioId, commentId });
  };

  return useMutation({
    mutationFn: (commentId: string) => deleteCommentFn(commentId),
    onSuccess: () => {
      toast.success("Comment deleted successfully");
      if (isScenariosApiEnabled) {
        queryClient.invalidateQueries({ queryKey: ["activity-log-v2", scenarioId] });
      } else {
        queryClient.invalidateQueries({ queryKey: ["activity-logs", scenarioId] });
      }
    },
    onError: () => {
      toast.error("Failed to delete comment. Please try again.");
    },
  });
};
